import { appConfigType } from "../types/api/apiConfig";

const appConfigDev: appConfigType = {
    api: {
        url: 'http://localhost:18002/'
    },
};

const appConfigProd: appConfigType = {
    api: {
        url: 'https://translation-api.bad-code.de/'
    },
}

const appConfig: appConfigType = process.env.NODE_ENV !== "production" ? appConfigDev : appConfigProd;

export { appConfig };
